import { errorHandler, successHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  list: null,
  deal: null,
  total: null,
  error: "",
  loading: false,
};

export const loadAllDealPaginated = createAsyncThunk(
  "deal/loadAllDealPaginated",
  async (arg) => {
    try {
      let query = queryGenerator(arg);
      const { data } = await axios.get(`deal?${query}`);
      return successHandler(data);
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const loadAllDeal = createAsyncThunk(
  "deal/loadAllDeal",
  async () => {
    try {
      const { data } = await axios.get(`deal?query=all`);
      return successHandler(data);
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const loadSingleDeal = createAsyncThunk(
  "deal/loadSingleDeal",
  async (id) => {
    try {
      const { data } = await axios.get(`deal/${id}`);
      return successHandler(data);
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const addDeal = createAsyncThunk(
  "deal/addDeal",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `deal`,
        data: values,
      });

      return successHandler(data, "Deal Created Successfully");
    } catch (error) {
      return errorHandler(error, true);
    }
  }
);

export const updateDeal = createAsyncThunk(
  "deal/updateDeal",
  async ({ id, values }) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `deal/${id}`,
        data: values,
      });
      return successHandler(data, "Deal Updated Successfully");
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const deleteDeal = createAsyncThunk(
  "deal/deleteDeal",
  async ({ id, status }) => {
    try {
      const { data } = await axios({
        method: "patch",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `deal/${id}`,
        data: { status },
      });
      return successHandler(data, "Deal Deleted Successfully");
    } catch (error) {
      return errorHandler(error);
    }
  }
);

export const clearDeal = createAsyncThunk("deal/clearDeal", async () => {
  return {};
});

const dealSlice = createSlice({
  name: "deal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAllDealPaginated.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadAllDealPaginated.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.getAllDeal;
        state.total = action.payload.totalDeal;
      })
      .addCase(loadAllDealPaginated.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(loadAllDeal.fulfilled, (state, action) => {
        state.list = action.payload;
      })
      .addCase(loadSingleDeal.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadSingleDeal.fulfilled, (state, action) => {
        state.loading = false;
        state.deal = action.payload;
      })
      .addCase(loadSingleDeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(clearDeal.fulfilled, (state) => {
        state.deal = null;
      });
  },
});

export default dealSlice.reducer;

